import React from "react";
import {
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { lightTable } from "../../../../../../../../styles/muiProps";
export default function AllocateToDrawingMaterialsComponent({
  mrqMaterials,
  setMrqMaterials,
  selectedDrawingMaterials,
  setSelectedDrawingMaterials,
  disabled,
}) {
  const drawingMaterials = [];

  mrqMaterials?.forEach((mm) => {
    drawingMaterials.push(...mm.materials);
  });

  const onAllocate = (e) => {
    const checked = e.target.checked;
    const id = e.target.value;

    if (checked) {
      setSelectedDrawingMaterials([
        ...selectedDrawingMaterials,
        drawingMaterials.find((dm) => dm.id === id),
      ]);
    } else {
      setSelectedDrawingMaterials(
        selectedDrawingMaterials.filter((dm) => dm.id !== id),
      );
    }
    console.log({
      e: e.target.value,
      checked: e.target.checked,
      selectedDrawingMaterials,
    });
  };

  const onSelectAll = (isSelectAll, rowId) => {
    const rowDrawingMaterials = mrqMaterials.find(
      (m) => m.id === rowId,
    ).materials;

    if (isSelectAll) {
      setSelectedDrawingMaterials(
        selectedDrawingMaterials.filter((sdm) => {
          const isExisted = rowDrawingMaterials
            .map((rdm) => rdm.id)
            .includes(sdm.id);
          console.log({ isExisted });
          return isExisted ? false : true;
        }),
      );

      setSelectedDrawingMaterials([
        ...selectedDrawingMaterials,
        ...rowDrawingMaterials,
      ]);
    } else {
      setSelectedDrawingMaterials(
        selectedDrawingMaterials.filter((sdm) =>
          rowDrawingMaterials.map((rdm) => rdm.id).includes(sdm.id),
        ),
      );
    }
  };

  return (
    <Box sx={{ maxHeight: 670, overflow: "auto" }}>
      {mrqMaterials?.map((m) => {
        const drawingMaterials = m?.materials;

        return (
          <Row
            row={m}
            key={m.id}
            onAllocate={onAllocate}
            onSelectAll={onSelectAll}
            selectedDrawingMaterials={selectedDrawingMaterials.filter((sdm) =>
              drawingMaterials.map((dm) => dm.id).includes(sdm.id),
            )}
            mrqMaterials={mrqMaterials}
            setMrqMaterials={setMrqMaterials}
            disabled={disabled}
          />
        );
      })}
    </Box>
  );
}

function Row({
  row,
  onAllocate,
  selectedDrawingMaterials,
  onSelectAll,
  mrqMaterials,
  setMrqMaterials,
  disabled,
}) {
  //   console.log({ row });
  const theme = useTheme();
  const drawingMaterials = row?.materials;

  const onChangeHeatNumber = (e) => {
    const heatNumber = e.target.value;

    setMrqMaterials(
      mrqMaterials.map((m) => {
        return m.id === row.id ? { ...m, heatNumber } : m;
      }),
    );
  };

  console.log("mrv row:", row);

  const table = useMaterialReactTable({
    data: [{ ...row }],
    columns: [
      {
        accessorKey: "length",
        header: "Dimension",
        size: 10,
      },
      {
        accessorKey: "procuredQty",
        header: "Procured Qty",
        size: 10,
      },
      {
        accessorKey: "unit",
        header: "Unit",
        size: 10,
      },
      {
        accessorKey: "Remaining Qty",
        header: "Remaining Qty",
        size: 10,
      },
      {
        accessorKey: "Location",
        header: "Location",
        size: 20,
      },
    ],
    ...lightTable,
  });

  return (
    <Paper
      sx={{
        p: 1,
        m: 1,
        backgroundColor: selectedDrawingMaterials.length
          ? theme.palette.action.selected
          : theme.palette.background.paper,
        borderRadius: "3px",
      }}
    >
      <Grid container>
        <Grid item xs={3} sx={{ px: 1 }}>
          <Typography sx={{ fontWeight: "bold", mb: 0.5 }}>
            Mark Numbers: ( {selectedDrawingMaterials.length}/
            {drawingMaterials.length} )
          </Typography>

          <Box sx={{ maxHeight: 120, overflow: "auto", mb: 0.5 }}>
            {drawingMaterials.map((dm) => {
              const isSelected = Boolean(
                selectedDrawingMaterials.find((sdm) => sdm.id === dm.id),
              );

              return (
                <FormControlLabel
                  sx={{
                    borderRadius: 1,
                    px: 0.75,
                    py: 0.25,
                    backgroundColor: isSelected
                      ? theme.palette.action.selected
                      : "transparent",
                  }}
                  control={
                    <Checkbox
                      sx={{ height: 4 }}
                      value={dm.id}
                      onChange={onAllocate}
                      disabled={disabled}
                      checked={isSelected}
                      icon={
                        !isSelected ? (
                          <CheckBoxOutlineBlankIcon />
                        ) : (
                          <CheckBoxIcon />
                        )
                      }
                      // checkedIcon={<CheckBoxIcon />}
                    />
                  }
                  label={dm.tagNumber}
                  key={dm.id}
                />
              );
            })}
          </Box>

          {/* <Box sx={{}}>
            <Button
              size="small"
              variant="contained"
              startIcon={<DoneAllIcon />}
              fullWidth
              onClick={() => {
                onSelectAll(
                  selectedDrawingMaterials.length !== drawingMaterials.length,
                  row.id,
                );
              }}
            >
              {selectedDrawingMaterials.length === drawingMaterials.length
                ? 'Unallocate All'
                : 'Allocate All'}
            </Button>
          </Box> */}
        </Grid>
        <Grid item xs={8}>
          <Typography sx={{ fontWeight: "bold", mb: 1 }}>
            Description:
          </Typography>

          <Box sx={{ maxHeight: 80, overflow: "auto", pl: 1, mb: 1 }}>
            {row.description}
          </Box>

          <MaterialReactTable table={table} />

          {selectedDrawingMaterials.length ? (
            <Box sx={{ pt: 1, display: "flex", alignItems: "center" }}>
              <Typography sx={{ width: 120 }}>Heat Number:</Typography>
              <TextField
                // label="Heat Number"
                value={row.heatNumber}
                onChange={onChangeHeatNumber}
                fullWidth
                size="small"
                disabled={disabled}
              />
            </Box>
          ) : (
            ""
          )}
        </Grid>
        <Grid xs={12}></Grid>
      </Grid>
    </Paper>
  );
}
